<template>
  <div class="flex justify-between h-12 mb-5">
    <div class="flex justify-center content-center w-3/5 gap-x-2">
      <div class="relative w-full">
        <div class="relative">
          <input
            class="w-full h-12 px-7 rounded-lg"
            v-model="selectedFilter.search"
            style="border: 1px solid #d3d3d3; padding-left:40px; padding-right: 10px;"
            type="search"
            :placeholder="searchPlaceholder"
            @change="handleSearch"
            @keyup="handleSearch"
          />
        </div>
        <div class="absolute top-0 right-4">
          <feather-icon icon="SearchIcon" svgClasses="h-5 w-5 mt-4 m-2" style="cursor: pointer;" @click="handleSearchLupa" />
        </div>
      </div>

      <div class="flex flex-row h-auto">
        <datepicker
          format="dd/MM/yyyy"
          :language="es"
          placeholder="Desde"
          input-class="w-32 h-12 p-3 rounded-lg border border-gray-d3"
          calendar-class="z-500"
          v-model="selectedFilter.from"
          @input="handleDatePicker"
        ></datepicker>
        <datepicker
          format="dd/MM/yyyy"
          :language="es"
          :disabled-dates="dateFromFilterDisabledDates"
          placeholder="Hasta"
          input-class="w-32 h-12 p-3 rounded-lg border border-gray-d3"
          calendar-class="z-500"
          v-model="selectedFilter.to"
          @input="handleDatePicker"
        ></datepicker>
        <feather-icon
          v-if="selectedFilter.from"
          @click="clearDateFilter()"
          icon="XIcon"
          svgClasses="h-5 w-5 mx-1 cursor-pointer"
        />
      </div>
    </div>

    <vs-button v-if="getOrderButton" @click="getOrders" color="rgb(13, 168, 205)">
      <vs-icon class="float-left mr-3" icon="update" size="18px" color="#fff" />
      <span>{{ titleButton }}</span>
    </vs-button>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";

export default {
  name: "FiltersTable",
  components: {
    Datepicker,
  },
  props: {
    getOrderButton: {
      type: Boolean,
      default: false
    },
    titleButton: String,
    searchPlaceholder: String,
    search: String,
  },
  data() {
    return {
      es: es,
      selectedFilter: {
        from: null,
        to: null,
        search: this.search,
      },
    };
  },
  created() {
    // El buscador emite en cada Backspace. Borrar "8420" caracter por caracter disparaba
    // cuatro consultas seguidas, y en "Por Enviar" cada una abre su propio loader: quedaban
    // cuatro overlays encadenados. Agrupando la rafaga sale una sola.
    this.emitSearch = _.debounce(() => {
      this.$emit("onSearch", this.selectedFilter);
    }, 400);
  },
  beforeDestroy() {
    this.emitSearch.cancel();
  },
  computed: {
    dateFromFilterDisabledDates() {
      return {
        to: new Date(this.selectedFilter.from),
      };
    },
  },
  methods: {

    clearDateFilter() {
      this.selectedFilter = {
        from: null,
        to: null,
        search: this.search,
      };
    },
    handleSearch(e) {
      // Enter es una orden explicita: sale en el momento y descarta lo que estuviera esperando.
      if (e.key === "Enter") {
        this.emitSearch.cancel();
        this.$emit("onSearch", this.selectedFilter);
        return;
      }
      if (e.key === "Backspace") this.emitSearch();
    },
    handleSearchLupa() {
      this.emitSearch.cancel();
      this.$emit("onSearch", this.selectedFilter);
    },
    handleDatePicker() {
      if(
        !this.selectedFilter.from && 
        !this.selectedFilter.to
      ) return;

      const selectedFilters = {
        from: moment(this.selectedFilter.from).format('YYYY-MM-DD'),
        to: moment(this.selectedFilter.to).add(1, 'days').format('YYYY-MM-DD'),
        search: this.selectedFilter.search
      };
      this.$emit("onSearch", selectedFilters);
    },
    getOrders(){
      this.$emit("getOrders");
    }
  },
};
</script>
